import React, { useEffect, useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import rightImage from '../Assest/image.png';

const points = [
  {
    text: (
      <>
        Create high-quality content and ideas in minutes, not hours.
      </>
    ),
  },
  {
    text: (
      <>
      	Write ads, blogs, scripts, and posts effortlessly without writer’s block.
      </>
    ),
  },
  {
    text: (
      <>
      	Get instant inspiration for marketing, design, and creative projects.
      </>
    ),
  },
  {
    text: (
      <>
        Save money by reducing dependency on multiple professionals for small tasks.
      </>
    ),
  },
  {
    text: (
      <>
      Improve productivity with ready prompts for any business or personal goal.
      </>
    ),
  },
  {
    text: (
      <>
    	Boost career and income opportunities using ChatGPT like a pro.
      </>
    ),
  },
];

const DigitalBusinessPoints = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkWidth = () => setIsMobile(window.innerWidth <= 768);
    checkWidth();
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  return (
    <div style={{ background: 'radial-gradient(107.67% 107.67% at 50% 20.81%, #000B3E 0%, #020202 100%)', color: '#fff', padding: '40px 15px', }}>
      <h2 style={{ textAlign: 'center', fontSize: '32px', marginBottom: '25px' }}>
        What You’ll Gain with Our Master ChatGPT  <span style={{ color: '#E49C47' }}>Course and 3000+ Ready Prompts</span>
      </h2>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '20px',
          marginBottom:'30px',
        }}
      >
        {/* Left - Bullet Points */}
        <div style={{ flex: '1 1 450px', maxWidth: '600px' }}>
          {points.map((item, index) => (
            <div
              key={index}
              style={{
                background: '#1A1A1A',
                borderRadius: '10px',
                padding: '20px 16px',
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',
                border: '1px solid #333',
                fontSize: '16px',
                lineHeight: '1.5',
              }}
            >
              <FaCheckCircle color="#F4A940" size={18} style={{ marginTop: 4 }} />
              <div>{item.text}</div>
            </div>
          ))}
        </div>

        {/* Right - Image */}
        <div style={{ flex: '1 1 250px', maxWidth: '350px' }}>
          <img
            src={rightImage}
            alt="Workshop Host"
            style={{
              width: isMobile ? '100%' : '80%',
              borderRadius: '10px',
              objectFit: 'cover',
              boxShadow: '0 0 10px rgba(0,0,0,0.3)',
              height: isMobile ? 'auto' : '90%',
              marginTop: isMobile ? '10px' : '20px',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DigitalBusinessPoints;
